// extracted by mini-css-extract-plugin
module.exports = {"ChartsContainer":"chartscomponent_ChartsContainer__2UdJ6","ChartsWrapper":"chartscomponent_ChartsWrapper__3Cw6D","ChartsTitleWrap":"chartscomponent_ChartsTitleWrap__3r_pD"};